import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/AppContext";
import { PageHeader, Loading } from "../components/PageHeader";
import { OrderDetails } from "../components/OrderDetails";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const orderId = params.get("order");
  const t = params.get("t");
  const { clear } = useCart();
  const [state, setState] = useState("checking");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    let tries = 0, stop = false;
    const poll = async () => {
      if (stop) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          const r = await api.get(`/orders/${orderId}`, { params: { t } });
          setOrder(r.data); setState("paid"); clear();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch (e) {
        console.warn("Payment status check failed; retrying", e);
      }
      if (++tries >= 20) return setState("timeout");
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sid, orderId, t, clear]);

  return (
    <div data-testid="order-success-page">
      <PageHeader eyebrow={state === "paid" ? "Payment confirmed" : "Order"} title={state === "paid" ? "Thank you — your order is confirmed" : "Confirming your payment"}>
        {state === "paid" && "A confirmation email with your links is on its way. Bookmark this page to return to your downloads."}
      </PageHeader>
      <div className="wb-container">
        {state === "checking" && <Loading />}
        {state === "paid" && order && <OrderDetails order={order} token={t} />}
        {state === "failed" && <p className="muted" data-testid="payment-failed">The payment session expired or failed. <Link to="/cart" className="gold">Return to cart</Link></p>}
        {state === "timeout" && (
          <p className="muted" data-testid="payment-timeout">
            We are still waiting for payment confirmation. <Link to={`/order/${orderId}?t=${t}`} className="gold">Check your order page</Link> in a moment.
          </p>
        )}
      </div>
    </div>
  );
}
